import { Post, Get } from "../Request/Api";

export default {
  state: {
    city:"",
    country:"",
    state:"",
    region:"",
    filterLocationType:"",
    Practitioner_Type_value:"",
    practitionerPageno: null,
    practitionerItemsPerPage: null,
    breakthroughpractitionerPageno: null,
    breakthroughpractitionerItemsPerPage: null,
    searchSepecializtion:"",
    Practitioner_Type_name:"",
    ViewPractitioner: null,
    practitionersList: [],
    breakthroughPractitionersList: [],
    practitionerDetail: [],
    allPractitionersList: [],
    allBreakthroughPractitionersList: [],
    latestPractitionersList:[],
  },
  getters: {
    GetPractitoner(state: any) {
      return state.ViewPractitioner;
    },
    GetPractitionersList(state: any) {
      return state.practitionersList;
    },
    GetBreakthroughPractitionersList(state: any) {
      return state.breakthroughPractitionersList;
    },
    GetLatestPractitionersList(state: any) {
      return state.latestPractitionersList;
    },
    GetAllPractitionersList(state: any) {
      return state.allPractitionersList;
    },
    GetAllBreakthroughPractitionersList(state: any) {
      return state.allBreakthroughPractitionersList;
    },
    GetPractitionerDetail(state: any) {
      return state.practitionerDetail;
    },
  },
  actions: {
    async GetPractitoner({ commit }: any, payload: any) {
      commit("SetPractitioner", payload);
    },
    async GetPractitionersList({ commit }: any, payload: any) {
      return await Get(
        `Practitioners/PractitionersList?search=${payload.search}&filters=${payload.filters}&page=${payload.page}&pageSize=${payload.pageSize}`
      ).then((res: any) => {
        payload.pageSize == "All"
          ? commit("SetAllPractitionersList", res.data.Data)
          : commit("SetPractitionersList", res.data.Data);
        return res.data.Data;
      });
    },
    async GetBreakthroughPractitionersList({ commit }: any, payload: any) {
      return await Get(
        `Practitioners/GetBreakthroughPractitionersList?page=${payload.page}&filters=${payload.filters}&pageSize=${payload.pageSize}`
      ).then((res: any) => {
        payload.pageSize == "All"
          ? commit("SetAllBreakthroughPractitionersList", res.data.Data)
          : commit("SetBreakthroughPractitionersList", res.data.Data);
        return res.data.Data;
      });
    },
    async GetPractitionerDetail({ commit }: any, payload: any) {
      return await Get(
        `Practitioners/PractitionerDetail?UserId=${payload.UserId}`
      ).then((res: any) => {
        commit("SetPractitionerDetail", res.data.Data);
      });
    },
    async GetLatestPractitionersList({ commit }: any, payload: any) {
      return await Get(
        `Practitioners/LatestPractitionersList`
      ).then((res: any) => {
        commit("SetLatestPractitionersList", res.data.Data);
      });
    },
  },
  mutations: {
    SetPractitioner(state: any, payload: any) {
      state.ViewPractitioner = payload;
    },
    SetPractitionersList(state: any, payload: any) {
      state.practitionersList = payload;
    },
    SetBreakthroughPractitionersList(state: any, payload: any) {
      state.breakthroughPractitionersList = payload;
    },
    SetAllPractitionersList(state: any, payload: any) {
      state.allPractitionersList = payload;
    },
    SetAllBreakthroughPractitionersList(state: any, payload: any) {
      state.allBreakthroughPractitionersList = payload;
    },
    SetLatestPractitionersList(state: any, payload: any) {
      state.latestPractitionersList = payload;
    },
    SetPractitionerDetail(state: any, payload: any) {
      if (payload[0]?.Users?.Bio) {
        const bio = payload[0]?.Users?.Bio;
        const sanitizedBio = bio
          .replace(/&nbsp;/gi, " ") // Forcefully remove all &nbsp;
          .replace(/<!--[\s\S]*?-->/g, "") // Remove comments
          .replace(/<style[\s\S]*?<\/style>/gi, "") // Remove style blocks
          .replace(/@font-face\s*{[^}]*}/gi, "") // Remove @font-face rules
          .replace(/\s*style="[^"]*"/gi, "") // Remove inline styles
          .replace(/\b(class|id|page|lang|align)="[^"]*"/gi, "") // Remove attributes
          .replace(/<(?!\/?(b|p)\s*\/?>)[^>]+>/gi, "") // Allow only <b> and <p>
          .replace(/\n{2,}/g, "\n") // Normalize multiple newlines to one
          .replace(/(<br>\s*)+/g, "<br>") // Remove consecutive <br> tags
          // .replace(/\s{2,}/g, " ") // Remove extra spaces
          .trim()
          .replace(/<br>\n/g, "<br>") // Handle <br> with trailing newlines
          .replace(/\n\n/g, "<br><br>") // Convert paragraphs to <br><br>
        
        const cleanedBio = sanitizedBio?.replace(/(<br>\s*)+/g, "<br>");
        payload[0].Users.Bio = cleanedBio;
      }
      state.practitionerDetail = payload;
    },
  },
};
